<template>
  <div>
    <v-progress-linear indeterminate v-if="carregando"></v-progress-linear>
    <v-form ref="form" v-else-if="candidato">
      <v-row>
        <v-col cols="12">
          <v-card flat>
            <v-card-title> Contato </v-card-title>
            <v-card-text>
              <v-row>
                <v-col xl="2" lg="2" md="2" sm="12" cols="12">
                  <v-text-field
                    label="DDD 1"
                    type="text"
                    v-model="candidato.ddd1"
                    v-mask="'##'"
                  ></v-text-field>
                </v-col>
                <v-col xl="4" lg="4" md="4" sm="12" cols="12">
                  <v-text-field
                    label="Telefone 1"
                    type="text"
                    v-model="candidato.telefone1"
                    v-mask="'#########'"
                  ></v-text-field>
                </v-col>
                <v-col xl="2" lg="2" md="2" sm="12" cols="12">
                  <v-text-field
                    label="DDD 2"
                    type="text"
                    v-mask="'##'"
                    v-model="candidato.ddd2"
                  ></v-text-field>
                </v-col>
                <v-col xl="4" lg="4" md="4" sm="12" cols="12">
                  <v-text-field
                    label="Telefone 2"
                    v-model="candidato.telefone2"
                    v-mask="'#########'"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col cols="12">
          <v-card flat>
            <v-card-title> Endereço </v-card-title>
            <v-card-text>
              <v-row>
                <v-col xl="3" lg="3" md="3" sm="12" cols="12">
                  <v-select
                    label="UF"
                    :rules="[(v) => !!v || 'Selecione sua UF']"
                    v-model="candidato.uf"
                    :items="estados"
                    item-text="Sigla"
                    item-value="Sigla"
                  ></v-select>
                </v-col>
                <v-col xl="9" lg="9" md="9" sm="12" cols="12">
                  <v-autocomplete
                    label="Cidade"
                    :rules="[(v) => !!v || 'Selecione sua cidade']"
                    v-model="candidato.cidade"
                    :items="getFilterCidades()"
                    item-text="Nome"
                    no-data-text="Nenhuma cidade encontrada"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <v-col cols="12">
          <v-card flat>
            <v-card-title> Escolaridade </v-card-title>
            <v-card-text>
              <v-row>
                <v-col xl="3" lg="4" md="4" sm="12" cols="12">
                  <escolaridades />
                </v-col>
                <v-col xl="9" lg="8" md="8" sm="12" cols="12">
                  <v-text-field
                    v-if="isGraducao()"
                    label="Graduação"
                    v-model="candidato.graduacao"
                    :rules="[(v) => !!v || 'Informe sua graduação']"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn
            rounded
            color="info"
            :loading="atualizando"
            @click="updateCandidato()"
            >Continuar<v-icon size="18" class="ml-2"
              >mdi-arrow-right</v-icon
            ></v-btn
          >
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { getEstados, getCidades } from "@/global";
import Escolaridades from "./Escolaridades.vue";
import axios from "axios";
import { mapMutations, mapState } from "vuex";

export default {
  components: { Escolaridades },
  computed: mapState("candidaturainterna", [
    "candidato",
    "escolaridades",
    "escolaridadeSelecionada",
  ]),
  data: () => ({
    graduacao: "",
    estados: getEstados(),
    cidades: getCidades(),
    atualizando: false,
    carregando: false,
  }),
  methods: {
    ...mapMutations("candidaturainterna", [
      "setCandidato",
      "setSelecionaEscolaridade",
      "setStep",
    ]),
    getFilterCidades() {
      var cidadesFiltrar = [];
      this.cidades
        .filter(
          (cid) =>
            this.estados.find((est) => est.Sigla == this.candidato.uf).ID ==
            cid.Estado
        )
        .forEach((data) => {
          cidadesFiltrar.push(data.Nome.toUpperCase());
        });
      return cidadesFiltrar;
    },
    isGraducao() {
      try {
        return this.escolaridades.find(
          (escol) => escol.codigo == this.escolaridadeSelecionada
        ).graduacao;
      } catch (error) {
        return false;
      }
    },
    async updateCandidato() {
      if (this.$refs.form.validate()) {
        this.atualizando = true;

        var data = {
          id: this.candidato.id,
          cidade: this.candidato.cidade,
          uf: this.candidato.uf,
          ddd1: this.candidato.ddd1 === "" ? 0 : parseInt(this.candidato.ddd1),
          telefone1:
            this.candidato.telefone1 === ""
              ? 0
              : parseInt(this.candidato.telefone1),
          ddd2: this.candidato.ddd2 === "" ? 0 : parseInt(this.candidato.ddd2),
          telefone2:
            this.candidato.telefone2 === ""
              ? 0
              : parseInt(this.candidato.telefone2),
          codescolaridade: parseInt(this.escolaridadeSelecionada),
          graduacao: this.candidato.graduacao,
        };

        await axios
          .post("/colaborador/candidatura-interna?funcao=ATUALIZAR", data)
          .then((res) => {
            if (res.data.success) {
              this.setStep(2);
            } else {
              this.$toasted.error(res.data.msg);
            }
          })
          .catch((e) => this.$toasted.error(e));
        this.atualizando = false;
      }
    },
  },
};
</script>

<style>
</style>